module.exports = __webpack_public_path__ + "img/47_28.466fc268.png";